import React, {useEffect, useState} from 'react';
import {Row, Button, Col} from 'react-bootstrap';
import styles from './contact-details.module.scss';
import {
  DropDown,
  FormGroup,
  RadioButton,
  TextInput
} from "../../../../../components/form/form";
import {useValidation} from "../../../../../hooks/use-validation";
import {
  contactDetailsObj,
  contactDetailsValidator
} from "../../../../../form-control/registration-form/contact-details-form-control";
import {getDeliveryModes} from "../../../../../helpr/orderFormData";
import {required} from "../../../../../helpr/generic-validation-rules";

const ContactDetails = ({context, controls}) => {
  //Unpack trade form main context
  const { initialRegistrationInfoState, registrationFormState, setRegistrationFormState } = context;
  const { next, back } = controls;
  const [sameAddressCheckbox, setSameAddressCheckbox] = useState({
    permanent: false,
    mailing: false
  })
  //Setup validator and transfer instruction state
  const contactDetailsState = useValidation(
    contactDetailsValidator,
    contactDetailsObj(registrationFormState),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getDropdownProps, forceSetField, getField } = contactDetailsState;

  //Setup initial trade info
  useEffect(() => {
    forceSetField('emailAddress', initialRegistrationInfoState.emailAddress);
  }, []);

  useEffect(() => {
    if (sameAddressCheckbox.permanent){
      forceSetField('permanentAddressStreetAddress', getField('presentAddressStreetAddress'));
      forceSetField('permanentAddressDistrictOrTown', getField('presentAddressDistrictOrTown'));
      forceSetField('permanentAddressCity', getField('presentAddressCity'));
      forceSetField('permanentAddressStateProvinceRegion', getField('presentAddressStateProvinceRegion'));
      forceSetField('permanentAddressCountry', getField('presentAddressCountry'));
      forceSetField('permanentAddressZipcode', getField('presentAddressZipcode'));
    } else {
      forceSetField('permanentAddressStreetAddress','');
      forceSetField('permanentAddressDistrictOrTown', '');
      forceSetField('permanentAddressCity', '');
      forceSetField('permanentAddressStateProvinceRegion', '');
      forceSetField('permanentAddressCountry', '');
      forceSetField('permanentAddressZipcode', '');
    }

  }, [sameAddressCheckbox.permanent]);

  useEffect(() => {
    if (sameAddressCheckbox.mailing){
      forceSetField('mailingAddressStreetAddress', getField('presentAddressStreetAddress'));
      forceSetField('mailingAddressDistrictOrTown', getField('presentAddressDistrictOrTown'));
      forceSetField('mailingAddressCity', getField('presentAddressCity'));
      forceSetField('mailingAddressStateProvinceRegion', getField('presentAddressStateProvinceRegion'));
      forceSetField('mailingAddressCountry', getField('presentAddressCountry'));
      forceSetField('mailingAddressZipcode', getField('presentAddressZipcode'));
    } else {
      forceSetField('mailingAddressStreetAddress','');
      forceSetField('mailingAddressDistrictOrTown', '');
      forceSetField('mailingAddressCity', '');
      forceSetField('mailingAddressStateProvinceRegion', '');
      forceSetField('mailingAddressCountry', '');
      forceSetField('mailingAddressZipcode', '');
    }

  }, [sameAddressCheckbox.mailing]);

  const nextPage = () => {
    const { formState, isFormValid } = validate();
    console.log(formState, isFormValid);
    if(isFormValid){
      const addresses = {
        presentAddress: {
          streetAddress: formState.presentAddressStreetAddress,
          districtOrTown: formState.presentAddressDistrictOrTown,
          city: formState.presentAddressCity,
          stateProvinceRegion: formState.presentAddressStateProvinceRegion,
          country: formState.presentAddressCountry,
          zipCode: formState.presentAddressZipcode
        },
        permanentAddress: {
          streetAddress: formState.permanentAddressStreetAddress,
          districtOrTown: formState.permanentAddressDistrictOrTown,
          city: formState.permanentAddressCity,
          stateProvinceRegion: formState.permanentAddressStateProvinceRegion,
          country: formState.permanentAddressCountry,
          zipCode: formState.permanentAddressZipcode
        },
        mailingAddress: {
          streetAddress: formState.mailingAddressStreetAddress,
          districtOrTown: formState.mailingAddressDistrictOrTown,
          city: formState.mailingAddressCity,
          stateProvinceRegion: formState.mailingAddressStateProvinceRegion,
          country: formState.mailingAddressCountry,
          zipCode: formState.mailingAddressZipcode
        }
      }
      setRegistrationFormState({
        ...registrationFormState,
        telNo: formState.telNo,
        emailAddress: formState.emailAddress,
        ...addresses,
        statementDeliveryMode: formState.statementDeliveryMode
      });
      next();
    }
  }

  const onSameAddress = key => {
    setSameAddressCheckbox({
      ...sameAddressCheckbox,
      [key]: !sameAddressCheckbox[key]
    })
  }

  return (
    <div className={styles['form-section']} >
      <Row>
        <Col lg={12}>
          <FormGroup header={'CONTACT DETAILS'}>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('telNo')} placeholder={""}>
                  Telephone Number:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput disabled={true} inputProps={getTextFieldProps('emailAddress')} placeholder={""}>
                  Email Address:
                </TextInput>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={'ADDRESS'}>
            <Row>
              <Col lg={12}>
                <div>
                  Present Address:*
                </div>
              </Col>
              <Col lg={10}>
                <TextInput inputProps={getTextFieldProps('presentAddressStreetAddress')} placeholder={"House/Lot/Block/Unit No., Floor & Building, Subdivision/Barangay/Village"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('presentAddressDistrictOrTown')} placeholder={"District/Town"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('presentAddressCity')} placeholder={"City"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('presentAddressStateProvinceRegion')} placeholder={"State/Province/R egion"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('presentAddressCountry')} placeholder={"Country"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('presentAddressZipcode')} placeholder={"ZIP Code"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Permanent Address:*<br/>
                  <span className={styles['sub-label']}>(if different from present address)</span>
                </div>
              </Col>
              <Col lg={12}>
                <input type="checkbox" onChange={() => onSameAddress('permanent')}/>
                {' '}
                same as above
              </Col>
              <Col lg={10}>
                <TextInput inputProps={getTextFieldProps('permanentAddressStreetAddress')} placeholder={"House/Lot/Block/Unit No., Floor & Building, Subdivision/Barangay/Village"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('permanentAddressDistrictOrTown')} placeholder={"District/Town"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('permanentAddressCity')} placeholder={"City"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('permanentAddressStateProvinceRegion')} placeholder={"State/Province/R egion"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('permanentAddressCountry')} placeholder={"Country"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('permanentAddressZipcode')} placeholder={"ZIP Code"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div>
                  Mailing Address:*<br/>
                  <span className={styles['sub-label']}>(if different from present and permanent address)</span>
                </div>
              </Col>
              <Col lg={12}>
                <input type="checkbox" onChange={() => onSameAddress('mailing')}/>
                {' '}
                same as above
              </Col>
              <Col lg={10}>
                <TextInput inputProps={getTextFieldProps('mailingAddressStreetAddress')} placeholder={"House/Lot/Block/Unit No., Floor & Building, Subdivision/Barangay/Village"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('mailingAddressDistrictOrTown')} placeholder={"District/Town"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('mailingAddressCity')} placeholder={"City"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('mailingAddressStateProvinceRegion')} placeholder={"State/Province/R egion"}>
                </TextInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('mailingAddressCountry')} placeholder={"Country"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('mailingAddressZipcode')} placeholder={"ZIP Code"}>
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <DropDown inputProps={getDropdownProps('statementDeliveryMode')} values={getDeliveryModes()}>
                  Statement Delivery Mode:*
                </DropDown>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['back-button']}>
            <Button variant="secondary" onClick={() => back()}>
              BACK
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['next-button']}>
            <Button onClick={() => nextPage()}>
              NEXT
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ContactDetails;
